import { Card, Icon, Label } from 'semantic-ui-react';

function Legend() {
    return (
        <Card fluid>
            <Card.Content>
                <Card.Header className="smallHardHeader">Legend</Card.Header>
                <Card.Description>
                    <p>
                        <Icon color="green" name="check" /> - Signifies the cell has confirmation messages
                    </p>
                    <p>
                        <Icon color="yellow" name="check" /> - Signifies the cell has both confirmation and warning
                        messages
                    </p>
                    <p>
                        <Icon color="yellow" name="plus" /> - Warning for a filed that is not presented in the current
                        model of the table.
                    </p>
                    <p>
                        <Icon color="red" name="info" /> - Signifies the cell has warning messages
                    </p>
                    <p>
                        <Icon color="red" name="warning sign" /> - Signifies the cell value does not match the field
                        type
                    </p>
                    <p>
                        <Label as={'span'} color="yellow">
                            M
                        </Label>{' '}
                        - Warning for scale that does not match the general table scale.
                    </p>
                    <p>
                        <Label as={'span'} color="yellow">
                            ANY
                        </Label>{' '}
                        - Warning for type that may be incorrect.
                    </p>
                    <div className="flex flex-align-center">
                        <table className="extraction-table import-table">
                            <thead>
                                <tr>
                                    <th className="bg-orange p-10">Imported Descriptors</th>
                                </tr>
                            </thead>
                        </table>
                        <p>- Blinking orange heading means that the might be a need for label normalization.</p>
                    </div>
                    <div className="flex flex-align-center mb-05">
                        <table className="extraction-table import-table">
                            <tbody>
                                <tr className="descriptor--highlighted">
                                    <td>Adjusted EBITDA</td>
                                    <td>
                                        <Label as={'span'}>NUMBER</Label>
                                    </td>
                                    <td>
                                        <Label as={'span'} color="grey">
                                            M
                                        </Label>
                                    </td>
                                    <td>200</td>
                                </tr>
                            </tbody>
                        </table>
                        <p>
                            - Signifies that the highlighted row is part of the calculation of the currently selected
                            row
                        </p>
                    </div>
                    <div className="flex flex-align-center mb-05">
                        <table className="extraction-table import-table">
                            <tbody>
                                <tr className="bg-hover">
                                    <td>Adjusted EBITDA</td>
                                    <td>
                                        <Label as={'span'}>NUMBER</Label>
                                    </td>
                                    <td>
                                        <Label as={'span'} color="grey">
                                            M
                                        </Label>
                                    </td>
                                    <td>200</td>
                                </tr>
                            </tbody>
                        </table>
                        <p>- Signifies that the highlighted row is the currently selected row</p>
                    </div>
                    <div className="flex flex-align-center mb-05">
                        <table className="extraction-table import-table">
                            <tbody>
                                <tr className="master-table__text">
                                    <td>Adjusted EBITDA</td>
                                    <td>
                                        <Label as={'span'}>NUMBER</Label>
                                    </td>
                                    <td>
                                        <Label as={'span'} color="grey">
                                            M
                                        </Label>
                                    </td>
                                    <td>200</td>
                                </tr>
                            </tbody>
                        </table>
                        <p>- Rows with lower opacity signifies that the field was not present in the image</p>
                    </div>
                    <div className="flex flex-align-center">
                        <table className="extraction-table import-table">
                            <tbody>
                                <tr>
                                    <td>Adjusted EBITDA</td>
                                    <td>
                                        <Label as={'span'}>NUMBER</Label>
                                    </td>
                                    <td>
                                        <Label as={'span'} color="grey">
                                            M
                                        </Label>
                                    </td>
                                    <td className="value--calculated">200</td>
                                </tr>
                            </tbody>
                        </table>
                        <p>- Data with lower opacity signifies that the value for the field is calculated</p>
                    </div>
                    <div className="flex flex-align-center">
                        <table className="extraction-table import-table">
                            <tbody>
                                <tr>
                                    <td>Adjusted EBITDA</td>
                                    <td>
                                        <Label as={'span'}>NUMBER</Label>
                                    </td>
                                    <td>
                                        <Label as={'span'} color="grey">
                                            M
                                        </Label>
                                    </td>
                                    <td className="value--master-table">200</td>
                                </tr>
                            </tbody>
                        </table>
                        <p>- Data with orange color signifies that the value for the field is taken master table</p>
                    </div>
                </Card.Description>
            </Card.Content>
        </Card>
    );
}

export default Legend;
